module.exports = __webpack_public_path__ + "img/default_img_2.435a11a8.png";